import React from "react";
import PropTypes from "prop-types";
import { RichText } from "./base/index";

/**
 * RichTextInlineImages
 * ---------------------------------------------------------------------------
 * Wraps <RichText> but constrains any <img> tags *inside* the HTML to the
 * current line‑height so they behave like glyph icons.
 *
 * Design goals
 *   • Inline images should never break line‑height or overflow.
 *   • Scale with the surrounding font‑size (e.g. inside <small> or headers).
 *   • Keep aspect‑ratio (auto‑width).
 *   • Vertically align text‑bottom for a clean baseline.
 *
 */

/* ------------------------------------------------------------------
   Sanitise the incoming HTML
   – drops width / height attributes CKEditor adds
   – adds class=\"rt-inline-img\" so we can style it with CSS
------------------------------------------------------------------- */
function normaliseInlineImages(rawHtml = "") {
  return (
    rawHtml
      // remove inline width / height attributes
      .replace(/\\s(?:width|height)=\"[^\"]*\"/gi, "")
      // add our helper class if it’s not already there
      .replace(/<img(?![^>]*class=)/gi, '<img class="rt-inline-img"')
      .replace(/<img([^>]*class=\")([^\"]*)\"/gi, '<img$1$2 rt-inline-img"')
  );
}

const RichTextInlineImages = ({
  html,
  handleAnchor = null,
  className = "",
  ...rest
}) => {
  const cleanedHtml = normaliseInlineImages(html);
  return (
    <RichText
      html={cleanedHtml}
      handleAnchor={handleAnchor}
      className={`rich-text-content rich-text-inline-images ${className}`}
      {...rest}
    />
  );
};

RichTextInlineImages.propTypes = {
  html: PropTypes.string.isRequired,
  handleAnchor: PropTypes.func,
  className: PropTypes.string,
};

export default RichTextInlineImages;
